module.exports = __webpack_public_path__ + "static/media/inactive-illustration.41f61111.svg";